import * as React from 'react';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { Label, InputProps, Col, Input, FormGroup, InputGroupAddon, InputGroup } from 'reactstrap';

// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //Input///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface IProps {
    labeltext?: string;
    inputinfo?: string;
    subRender?: any;
    validate?: any;
    invalid?: boolean;
    small?: boolean;
    maxValue?: string;
    minDate?: boolean;
}
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //Wrapped Input///////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IWrappedProps {
    md?: number | string;
    xs?: number | string;
    sm?: number | string;
    lg?: number | string;
    xl?: number | string;
    size?: number | string;
}
export type WrappedInputProps = InputProps & IWrappedProps & IProps;


const DateTime = (props: WrappedInputProps) => {
    const className = `form-control-sm ${!props.disabled ? ' calendar-datepicker' : 'calendar-datepicker-disabled'}`;
    const commonProps = {
        selected: props.value,
        className,
        placeholderText: props.placeholder ? (props.placeholder + (props.required ? " *" : "")) : "",
        onChange: (event) => {
            if (props.onChange) {
                const onChange: any = props.onChange;
                onChange({ currentTarget: { value: event } });
            }
        }
    }
    const formProps = {
        name: props.name,
        disabled: props.disabled,
        required: props.required
    }
    if (props.type === "date") {
        const dateProps = {
            dateFormat: "DD/MM/YYYY",
            showYearDropdown: true,
            scrollableYearDropdown: true,
            yearDropdownItemNumber: 15,
            maxDate: props.maxValue ? props.maxValue : moment()
        }
        return <DatePicker autoComplete="off" {...commonProps} {...formProps} {...dateProps} />

    } else {
        const timeProps = {
            showTimeSelect: true,
            timeIntervals: 15,
            dateFormat: "DD/MM/YYYY - hh:mm A",
            timeCaption: "time",
            maxDate: props.maxValue ? props.maxValue === "null" ? undefined : props.maxValue : moment(),
            minDate: props.minDate ? moment().add(1, 'day') : null
        }
        return <DatePicker autoComplete="off" {...commonProps} {...formProps} {...timeProps} />
    }
}

export const WrappedInput = (props: WrappedInputProps) => {
    const placeholder = props.placeholder ? (props.placeholder + (props.required ? " *" : "")) : "";
    return (
        <Col md={props.md ? props.md : 12} xs={props.xs} sm={props.sm} lg={props.lg} xl={props.xl} size={props.size} className={props.className}>
            <FormGroup>
                {props.labeltext && <Label className="input-margin-top input-label" for={props.id}>{props.labeltext}</Label>}
                <InputGroup className={props.small ? "input-group-sm" : ""}>
                    {props.prefix && <InputGroupAddon addonType="prepend">{props.prefix}</InputGroupAddon>}
                    {props.type === 'date' || props.type === 'datetime' ?
                        <DateTime {...props} /> :
                        <Input data-invalid={props.invalid ? props.invalid : false} className={props.small ? "form-control-sm" : ""} {...props} placeholder={placeholder} />}
                </InputGroup>
                {props.inputinfo && <small className="form-text text-muted">{props.inputinfo}</small>}
                {props.subRender && props.subRender()}
            </FormGroup>
        </Col>
    )
}


// WEBPACK FOOTER //
// ./src/share/components/Input/Input.tsx